/**
 * Bundle cart rendering — expand/collapse and bulk delete for grouped bundle rows.
 * Loaded from cart-products.liquid (type="module" ensures single execution).
 */

document.addEventListener('click', (e) => {
  const deleteBtn = e.target.closest('.bc-bundle-delete-btn');
  if (deleteBtn) {
    e.preventDefault();
    deleteBundleItems(deleteBtn);
    return;
  }

  const toggleBtn = e.target.closest('.bc-bundle-toggle-btn');
  if (toggleBtn) {
    e.preventDefault();
    toggleBundleDetails(toggleBtn);
  }
});

async function deleteBundleItems(btn) {
  const bundleKeys = (btn.dataset.bundleKeys || '').split(',').map(k => k.trim()).filter(Boolean);
  if (!bundleKeys.length) return;

  btn.disabled = true;

  const cartComponents = document.querySelectorAll('cart-items-component');
  const sectionIds = [...cartComponents].map(el => el.dataset.sectionId).filter(Boolean);

  const updates = {};
  bundleKeys.forEach(key => { updates[key] = 0; });

  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        updates,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: 'bc-bundle-delete',
        data: {
          itemCount: data.item_count,
          sections: data.sections || {},
        },
      },
    }));
  } catch (err) {
    console.error('[BC] Bundle delete error:', err);
    btn.disabled = false;
  }
}

function toggleBundleDetails(btn) {
  const row = btn.closest('.bc-bundle-row');
  const list = row?.querySelector('.bc-bundle-items-list');
  if (!list) return;

  const isExpanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!isExpanded));
  list.hidden = isExpanded;
  row.classList.toggle('bc-bundle-row--open', !isExpanded);
}
